import { ButtonSet, Form } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm, FieldErrors } from "react-hook-form";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import http from "../../http-common";
import Card from "../../components/Card/Card";
import useAuth from "../../hooks/useAuth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Tabs } from "carbon-components-react";
import { Tab } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import PersonalDataForm from "../../components/Forms/PersonalDataForm";
import CurrentOccupationForm from "../../components/Forms/CurrentOccupationForm";
import BusinessSectorForm from "../../components/Forms/BusinessDetailsForm";
import BusinessPhaseForm from "../../components/Forms/BusinessPhaseForm";
import WorkAreaForm from "../../components/Forms/WorkAreaForm";
import TrainingAreaForm from "../../components/Forms/TrainingAreaForm";
import { basicCandidatureSchema } from "../../services/SchemaService";
import { yupResolver } from "@hookform/resolvers/yup";
import AvailabilityForm from "../../components/Forms/AvailabilityForm";
import ApplicationDisclaimer from "../../components/Miscellaneous/ApplicationDisclaimer";
import BusinessDetailsForm from "../../components/Forms/BusinessDetailsForm";

const CreateCandidaturePage = () => {
  const [uuid, setUuid] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedOccupations, setSelectedOccupations] = useState([]);
  const [selectedBusinessPhases, setSelectedBusinessPhases] = useState([]);
  const [selectedBusinessSectors, setSelectedBusinessSectors] = useState([]);
  const [selectedWorkAreas, setSelectedWorkAreas] = useState([]);
  const [selectedTrainingProviders, setSelectedTrainingProviders] = useState(
    []
  );
  const [selectedTrainingAreas, setSelectedTrainingAreas] = useState([]);
  const { user, isCompetitor } = useAuth();
  const [hasOwnBusiness, setHasOwnBusiness] = useState(false);
  const [isEmployed, setIsEmployed] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const windowCode = Number(searchParams.get("window")) || 1;
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(basicCandidatureSchema),
    mode: "onSubmit",
  });

  const onSubmit = async (data) => {
    try {
      data.businessPhases = selectedBusinessPhases;
      data.workAreas = selectedWorkAreas;
      data.pastTrainings = selectedTrainingProviders;
      data.trainingPreferences = selectedTrainingAreas;
      data.windowCode = windowCode;
      const response = await http.post("/applications", data);
      toast.success("Candidatura Registada com sucesso");
      navigate("../candidature/" + response.data);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  const getCandidatureUuid = async () => {
    try {
      const response = await http.get(
        `/applications/uuid-by-phone-number/${user.username}?windowCode=${windowCode}`
      );
      if (response.data) {
        navigate("../candidature/" + response.data);
      }
    } catch (error) {
      // No candidature yet for this window - stay on the creation form.
    }
  };

  useEffect(() => {
    if (isCompetitor) {
      getCandidatureUuid();
      setValue("name", user.firstName + " " + user.lastName);
      setValue("phoneNumber", user.username);
      setValue("email", user.email);
    }
  }, []);

  useEffect(() => {
    if (isSubmitted && Object.keys(errors).length > 0) {
      setActiveTab(1);
      toast.error(
        "Erro de validação do formulário. Verifique se não tem campos obrigatórios não preenchidos"
      );
    }
  }, [isSubmitted, errors]);

  useEffect(() => {}, [hasOwnBusiness]);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Registar Candidatura">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Tabs
          scrollIntoView={false}
          selected={activeTab}
          type={"container"}
          onSelectionChange={(e) => setActiveTab(e)}
        >
          <Tab href="#" id="tab-0" label="Declaração">
            <ApplicationDisclaimer />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-0" label="Dados Pessoais">
            <PersonalDataForm
              reset={reset}
              register={register}
              control={control}
              errors={errors}
              hasOwnBusiness={hasOwnBusiness}
              setHasOwnBusiness={setHasOwnBusiness}
              disbaleBusinessCheck={false}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>

          {hasOwnBusiness && (
            <Tab href="#" id="tab-3" label="Negócio">
              <BusinessDetailsForm
                register={register}
                control={control}
                errors={errors}
                selectedBusinessPhases={selectedBusinessPhases}
                setSelectedBusinessPhases={setSelectedBusinessPhases}
                selectedWorkAreas={selectedWorkAreas}
                setSelectedWorkAreas={setSelectedWorkAreas}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>
          )}

          {hasOwnBusiness && (
            <Tab href="#" id="tab-6" label="Capacitação">
              <TrainingAreaForm
                register={register}
                errors={errors}
                selectedTrainingProviders={selectedTrainingProviders}
                setSelectedTrainingProviders={setSelectedTrainingProviders}
                selectedTrainingAreas={selectedTrainingAreas}
                setSelectedTrainingAreas={setSelectedTrainingAreas}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
              </div>
            </Tab>
          )}
        </Tabs>
        {hasOwnBusiness && (
          <ButtonSet>
            <SubmitButton className={"emprega-bg-green"} />
            <CancelButton />
          </ButtonSet>
        )}
      </Form>
    </Card>
  );
};

export default CreateCandidaturePage;
